import actionTypes from 'redux/actions/actionTypes';
import initialState from 'redux/initialState';

import { CoOwner } from 'types';

import { actionTypes as customTypes } from 'modules/_shared/redux/resetActions';

type CoOwnerAction = {
  type: string;
  coOwners?: CoOwner[];
  coOwner?: CoOwner;
  coOwnerId?: string;
};

const resetStateSociety = (): CoOwner[] => initialState.coOwners;

const createCoOwner = (coOwners: CoOwner[], action: CoOwnerAction): CoOwner[] =>
  action.coOwner ? [...coOwners, action.coOwner] : coOwners;

const getCoOwners = (action: CoOwnerAction): CoOwner[] => action.coOwners || [];

const updateCoOwner = (coOwners: CoOwner[], action: CoOwnerAction): CoOwner[] =>
  coOwners
    ?.map((coOwner: CoOwner) =>
      coOwner._id === action.coOwner?._id ? action.coOwner : coOwner
    )
    .filter((coOwner): coOwner is CoOwner => coOwner !== undefined);

const deleteCoOwner = (coOwners: CoOwner[], action: CoOwnerAction): CoOwner[] =>
  coOwners?.filter((coOwner: CoOwner) => coOwner._id !== action.coOwnerId);

const reducer = (
  coOwners: CoOwner[] = initialState.coOwners,
  action: CoOwnerAction
) => {
  switch (action.type) {
    case customTypes.RESET_STATE_SOCIETY:
      return resetStateSociety();

    case actionTypes.CREATE_COOWNER:
      return createCoOwner(coOwners, action);

    case actionTypes.GET_COOWNERS:
      return getCoOwners(action);

    case actionTypes.UPDATE_COOWNER:
      return updateCoOwner(coOwners, action);

    case actionTypes.DELETE_COOWNER:
      return deleteCoOwner(coOwners, action);

    default:
      return coOwners;
  }
};

export default reducer;
